"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageSchema = void 0;
const zod_1 = require("zod");
const platform_types_1 = require("../core/platform.types");
exports.messageSchema = zod_1.z
    .object({
    _id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    platform: zod_1.z.enum([platform_types_1.PlatformEnum.WHATSAPP, platform_types_1.PlatformEnum.APP]),
    originalTranscript: zod_1.z.string().nullish(),
    audioDuration: zod_1.z.number().nullish(),
    content: zod_1.z.string().nullish(),
    type: zod_1.z.enum(["text", "audio"]),
    from: zod_1.z.enum(["user", "bot", "system"]),
    evaluation: zod_1.z
        .object({
        isCorrect: zod_1.z.boolean().nullish(),
        message: zod_1.z.string().nullish(),
        fixed: zod_1.z.string().nullish(),
        score: zod_1.z.number().nullish(),
        explanation: zod_1.z.string().nullish(),
        imageURL: zod_1.z.string().nullish(),
    })
        .nullish(),
    // @deprecated
    grammar: zod_1.z.object({
        evaluated: zod_1.z.boolean().nullish(),
        erroredCategories: zod_1.z.array(zod_1.z.string()),
        correctCategories: zod_1.z.array(zod_1.z.string()),
    }),
    pronunciationEvaluation: zod_1.z
        .object({
        imageURL: zod_1.z.string().nullish(),
    })
        .nullish(),
    mergedEvaluation: zod_1.z
        .object({
        score: zod_1.z.number().nullish(),
        scoreImageURL: zod_1.z.string().nullish(),
        imageURL: zod_1.z.string().nullish(),
        feedbackExplanationImageURL: zod_1.z.string().nullish(),
    })
        .nullish(),
    // relations
    userId: zod_1.z.string(),
    conversationId: zod_1.z.string(),
})
    .passthrough();
//# sourceMappingURL=message.js.map